import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/coupons';

export const couponsService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  get: (id) => apiClient.get(`${base}/${id}`),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.patch(`${base}/${id}`, payload),
  remove: (id) => apiClient.delete(`${base}/${id}`),
  setStatus: (id, isActive) => apiClient.patch(`${base}/${id}/status`, { isActive }),
  redemptions: (id, params) => apiClient.get(`${base}/${id}/redemptions`, { params: cleanParams(params) }),
};

export default couponsService;
